import { css } from 'linaria'

export default css`
  display: flex;
  align-items: center;
  justify-content: center;
`
